import { render, staticRenderFns } from "./CollapsibleCard.vue?vue&type=template&id=55c9c7c6"
import script from "./CollapsibleCard.vue?vue&type=script&lang=ts"
export * from "./CollapsibleCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports